import React from 'react';
import LeadFormRibbon from './LeadFormRibbon';

interface IFomo {
  highlight_subtitle: string;
  highlight_subtitle_second_line: string;
}

interface ILeadFormHeader {
  title: string;
  description?: string;
  fomo: IFomo;
  discountCode?: string;
  showRibbon: boolean;
}

const LeadFormHeader = (props: ILeadFormHeader) => {
  const { showRibbon, description, title, discountCode, fomo } = props;

  const DefaultDescription = () =>
    (
      <>
        <div className="text-white lg:text-center lg:w-full lg:text-lg leadform__title--content h-4 my-4">
          <span className="mr-3 leadform__title--content__text">
            Diskon Terbaik
            <span className="delimiter-dot-ascii lg:hidden" />
          </span>
          <span className="mr-3 leadform__title--content__text">
            500+ Pilihan
            <span className="delimiter-dot-ascii lg:hidden" />
          </span>
          <span className="mr-3 leadform__title--content__text">Bantuan Klaim</span>
        </div>
        {discountCode && (
          <div className="lg:text-center lg:w-full lg:mt-2">
            <div
              className="text-xs font-semibold inline-block py-1 px-2
                rounded text-white bg-pastel-red uppercase last:mr-0 mr-1"
            >
              Gunakan Kode:
              {' '}
              {discountCode}
            </div>
          </div>
        )}
      </>
    );

  const DynamicDescription = () =>
    (
      <>
        <div className="text-white lg:text-center lg:w-full lg:text-lg leadform__title--content h-4 my-4">
          {description}
        </div>
        {discountCode && (
          <div className="lg:text-center lg:w-full lg:mt-2">
            <div
              className="text-xs font-semibold inline-block py-1 px-2
                rounded text-white bg-pastel-red last:mr-0 mr-1"
            >
              Gunakan Kode:
              {' '}
              {discountCode}
            </div>
          </div>
        )}
      </>
    );

  return (
    <div className="pt-4 lg:pt-8">
      <h1 className="text-xl w-3/4 font-bold text-white lg:text-center lg:text-3xl lg:w-full">
        {title ?? `Asuransi Terbaik ${new Date().getFullYear()}, Bandingkan Polis!`}
      </h1>
      {description ? <DynamicDescription /> : <DefaultDescription />}
      {showRibbon && <LeadFormRibbon fomo={fomo} />}
    </div>
  );
};

export default LeadFormHeader;
